<template>
  <div class="tableRedisDiv">
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableRedisDate"
      style="width: 100.1%"
      class="parentTableDiv"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <!-- <span @click="doDelete(index, row)"> -->
        <Button type="info" size="small" @click="rowClick(row)">{{
          $t("alarms.common.details")
        }}</Button>
        <Button type="error" size="small" @click="handleDel(index, row)">{{
          $t("alarms.common.delete")
        }}</Button>
        <!-- </span> -->
      </template>
      <!-- <template slot-scope="{ row, index }" slot="child">
        <Table :columns="childColums" :data="row.awsDocDbInstanceDTOS"></Table>
      </template> -->
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="redisDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDeletes") }}
          <!-- {{ deleteName }} -->
          <!-- {{ $t("alarms.common.allWarningRules") }} -->
          ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeRedis()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableRedisVue = {};
import TableExpand from "./TableExpand.vue";
export default {
  name: "TableRedis",
  components: {
    TableExpand
  },
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      redisDelmodal: false,
      isDisable: false,
      modal_loading: false,
      companyId: "",
      cacheClusterId: "",
      deleteName: "",
      getRowData: {},
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h("Table", {
              props: {
                columns: [
                  {
                    type: "expand",
                    width: 50,
                    render: (h, params) => {}
                  },
                  {
                    title: "",
                    key: "accountTypeName"
                  },
                  {
                    title: "",
                    key: "accountName"
                  },
                  {
                    title: this.$t("DocDBMonitor.ClusterIdentifier"),
                    key: "dbInstanceIdentifier"
                  },
                  {
                    title: this.$t("DocDBMonitor.role"),
                    key: "roleName"
                  },
                  {
                    title: this.$t("DocDBMonitor.status"),
                    key: "status"
                  },
                  {
                    title: this.$t("ElasticSearch.operation"),
                    render: (h, params) => {
                      return h("div", [
                        h(
                          "Button",
                          {
                            props: {
                              type: "info",
                              size: "small"
                            },
                            style: {
                              marginRight: "5px"
                            },
                            on: {
                              click: () => {
                                this.rowClick(params.row);
                              }
                            }
                          },
                          this.$t("alarms.common.details")
                        ),
                        h(
                          "Button",
                          {
                            props: {
                              type: "error",
                              size: "small"
                            },
                            on: {
                              click: () => {
                                this.handleDel(params.row._index, params.row);
                              }
                            }
                          },
                          this.$t("alarms.common.delete")
                        )
                      ]);
                    }
                    // slot: "delChild"
                  }
                ],
                //表头
                data: params.row.awsDocDbInstanceDTOS //内部表格展示的数据
              }
            });
          }
        },
        // 账号类型  账号名称  集群标识符
        {
          title: this.$t("DocDBMonitor.accountTypes"),
          key: "accountTypeName"
        },
        {
          title: this.$t("DocDBMonitor.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("DocDBMonitor.ClusterIdentifier"),
          key: "dbClusterIdentifier"
        },
        {
          title: this.$t("DocDBMonitor.role"),
          key: "roleName"
        },
        {
          title: this.$t("DocDBMonitor.status"),
          key: "status"
        },
        {
          title: this.$t("ElasticSearch.operation"),
          slot: "delete"
        }
      ],
      tableRedisDate: []
    };
  },
  beforeCreate: function() {
    tableRedisVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableRedisVue.companyId = val;
    });
    eventBus.$on("accountType", function(val) {
      tableRedisVue.accountType = val;
    });
    eventBus.$on("accountName", function(val) {
      tableRedisVue.accountName = val;
    });
    eventBus.$on("dbClusterIdentifier", function(val) {
      tableRedisVue.dbClusterIdentifier = val;
    });
  },
  mounted: function() {},
  methods: {
    expandRow(params) {
      //判断当前行是否展开，如果未展开，执行以下方法，先展开再请求接口加载到tabledata中当前data index 后
      if (!this.tableRedisDate[params.index].isDown) {
        // getRecordData 拿到要显示的数据
        getRecordData()
          .then(res => {
            return res.data;
          })
          .then(data => {
            this.tableRedisDate[params.index].isDown = true;
            let newArrayData = data;
            this.tableRedisDate[params.index].totals = newArrayData.length; //将展开操作查询到的数据总条数加到当前行数据的totals上
            newArrayData.map(item => {
              item.isExpand = true;
              item.upLevelIndex = params.index;
            });
            newArrayData.map((value, key) => {
              this.tableRedisDate.splice(params.index + key + 1, 0, value);
            });
          });
      } else {
        //如果当前行已展开，则隐藏
        this.tableRedisDate[params.index].isDown = false;
        this.tableRedisDate.splice(params.index + 1, params.row.totals);
      }
    },
    showAll: function() {
      tableRedisVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      //列表分页
      this.$api.DocDB.documentDBClusterSelect({
        pageNum: this.current,
        pageSize: this.pageSize,
        companyId: tableRedisVue.companyId,
        // cacheEngine: 1,
        dbClusterIdentifier: tableRedisVue.dbClusterIdentifier,
        accountType: tableRedisVue.accountType,
        accountName: tableRedisVue.accountName
      }).then(res => {
        this.tableRedisDate = res.data.records;
        // 当前页
        this.current = res.data.current;
        // 总条数
        this.dataTotal = res.data.total;
      });
    },
    changePage: function(current) {
      this.current = current;
      tableRedisVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableRedisVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("companyId");
      eventBus.$off("cacheClusterId");
    },
    // 删除
    /****************************************************/
    // doDelete: function(index, row) {
    //   console.log("index", this.tableRedisDate[index]);
    //   this.lineIndex = index;
    //   this.deleteName = this.tableRedisDate[index].cacheClusterId;
    //   this.getRowData = row;
    // },
    handleDel(index, row) {
      this.redisDelmodal = true;
      this.lineIndex = index;
      // this.deleteName = this.tableRedisDate[index].cacheClusterId;
      this.getRowData = row;
    },
    removeRedis: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      let obj = {
        docDbId: this.getRowData.id,
        roleName: this.getRowData.roleName
      };
      //删除
      this.$api.DocDB.documentDBClusterDelete(obj).then(res => {
        this.modal_loading = true;
        setTimeout(() => {
          if (
            lineIndex == 0 &&
            (this.current - 1) * this.pageSize + 1 == this.dataTotal
          ) {
            this.current = this.current - 1;
          }
          this.dataTotal = this.dataTotal - 1;
          tableRedisVue.getData();
          this.isDisable = false;
          this.modal_loading = false;
          this.redisDelmodal = false;
          this.$Message.success("删除成功");
        }, 1000);
      });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/DocDBMonitor/DocDBDetail",
        query: {
          id: row.id,
          accountId: row.accountId,
          cacheClusterId: row.cacheClusterId,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          instanceId: row.cacheClusterId,
          type: row.accountType,
          roleName: row.roleName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
.tableRedisDiv >>> td.ivu-table-expanded-cell {
  padding: 0;
  border-bottom: none;
}
.expandDiv >>> .ivu-table-header thead tr {
  display: none;
}
.expandDiv >>> .ivu-table-wrapper {
  /* border: none; */
  border-top-color: #fff;
  border-left-color: #fff;
  border-bottom-color: #fff;
}
.expandDiv >>> .ivu-table-expanded-cell {
  padding: 0;
}
.expandDiv >>> .ivu-table td {
  padding: 0 !important;
  border-bottom: none;
}
.expandDiv >>> .ivu-table-cell-with-expand {
  display: none;
}
/* .tableRedisDiv >>> .ivu-table-cell-expand {
  display: none;
} */
.tableRedisDiv >>> .ivu-table-tbody > .ivu-table-expanded-cell {
}
.tableRedisDiv
  >>> .ivu-table-tbody
  .ivu-table-expanded-cell
  .ivu-table-header
  thead
  tr {
  display: none;
}
/* .tableRedisDiv >>> .ivu-table-tbody .ivu-table-row .ivu-table-cell-with-expand {
  display: none;
} */
/* .tableRedisDiv
  >>> .ivu-table-tbody
  tr:not(first-child)
  .ivu-table-row
  td:first-child {
  display: none;
} */
.tableRedisDiv
  >>> .ivu-table-tbody
  tr:not(.ivu-table-row)
  .ivu-table-cell-with-expand {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/DocDBMonitor/TableRedis.vue